import { render } from "./CIS-Resource-Partner.vue?vue&type=template&id=2b355ec2&scoped=true"
import script from "./CIS-Resource-Partner.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Partner.vue?vue&type=script&lang=js"

import "./CIS-Resource-Partner.vue?vue&type=style&index=0&id=2b355ec2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b355ec2"]])

export default __exports__